import { useCampaignCreateContext } from '@/pages/campaign/CreatePage/context';
import { CAMPAIGN_TABS } from '@/pages/campaign/CreatePage/types';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Tab, Tabs, useTheme } from '@mui/material';

const CustomTabs = styled(Tabs)`
    height: 100%;
    display: flex;
    justify-content: space-around;

    left: 50%;
    position: absolute;
    transform: translate(-50%, 0);

    & .Mui-selected {
        color: ${({ theme }) => theme.colors.primary.main} !important;
    }

    & .MuiTabs-flexContainer {
        position: relative;
        height: 100%;
    }

    & .MuiTabs-indicator {
        z-index: 2;
        background-color: ${({ theme }) => theme.colors.primary.main} !important;
    }
`;

const CustomTab = styled(Tab)<{ isError?: boolean }>`
    text-transform: none;
    color: ${({ isError, theme }) => (isError ? theme.colors.error.main : theme.colors.black[550])} !important;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.6rem;
    color: ${theme.colors.black[600]};
`;

export const CampaignTabs = () => {
    const theme = useTheme();
    const { currentTab, setCurrentTab } = useCampaignCreateContext();

    return (
        <CustomTabs
            TabIndicatorProps={{ style: { backgroundColor: theme.colors.black.main } }}
            value={currentTab}
            onChange={(_e, v) => setCurrentTab(v)}>
            <CustomTab value={CAMPAIGN_TABS.AVATAR} label="Avatar" id="campaign-avatar-tab" />
            <CustomTab value={CAMPAIGN_TABS.VOICE_SCRIPT} label="Voice & Script" id="campaign-voice-tab" />
            <CustomTab value={CAMPAIGN_TABS.VIDEO_PAGE} label="Display campaign" id="campaign-video-tab" />
        </CustomTabs>
    );
};
